// Lib
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { withFormik, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import moment from 'moment'

// Images

// Include in project
import Color from 'abstracts/export.module.scss'
import styles from './index.module.scss'
import { useDashboard } from 'hooks'
import type { RootState } from 'states/store'
import { ByZoneAchievedRtl } from 'utils/generated'
import { SelectSingle, DatePickers, Notification } from 'component'

const BarGraphRTL: React.FC = () => {
  const { values } = useFormikContext<any>()

  const optionsBarTotalStar: any = {
    plugins: {
      title: {
        display: true,
        text: 'No of RTL joined',
      },
      datalabels: {
        display: true,
        color: 'black',
      },
      legend: {
        display: true,
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Month',
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'No of RTL',
        },
      },
    },
  }

  const getZoneListReducer = useSelector((state: RootState) => state.zone)
  const { getByZoneAchivedRtl, dataByZoneAchivedRtl, errMsg } = useDashboard()
  useEffect(() => {
    if (!values.timeDuration[0]) return
    if (!values.timeDuration[1]) return

    getByZoneAchivedRtl({
      variables: {
        startDate: values.timeDuration[0].toISOString(),
        endDate: values.timeDuration[1].toISOString(),
        zoneID: values.zoneID,
      },
    })
  }, [values.zoneID, values.timeDuration, getZoneListReducer.zoneListOption])

  const labels = dataByZoneAchivedRtl?.items?.map((data: ByZoneAchievedRtl) => data.provinceName)

  const dataBarTotalStar = {
    labels,
    datasets: [
      {
        label: 'No of RTL achieved',
        data: dataByZoneAchivedRtl?.items?.map((data: ByZoneAchievedRtl) => data.achievedRTL),
        backgroundColor: `${Color.successBorder}`,
      },
      {
        label: 'No of RTL not achieved',
        data: dataByZoneAchivedRtl?.items?.map((data: ByZoneAchievedRtl) => data.notAchievedRTL),
        backgroundColor: `${Color.grey200}`,
      },
    ],
  }

  const [isOpen, setIsOpen] = useState<boolean>(false)
  useEffect(() => {
    if (errMsg) return setIsOpen(true)
  }, [errMsg])
  return (
    <>
      <div className={styles.filter}>
        <SelectSingle
          name="zoneID"
          label={'Zone'}
          option={getZoneListReducer.zoneListOption}
          disabled={false}
          require
        />
        <DatePickers name="timeDuration" label={'Time Duration'} require />
      </div>
      <Bar options={optionsBarTotalStar} data={dataBarTotalStar} />
      <Notification
        title="Error From Server"
        description={errMsg}
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        type="danger"
      />
    </>
  )
}

const EnhancedBarGraphRTL = withFormik({
  mapPropsToValues: () => ({
    zoneID: 1,
    timeDuration: [moment().subtract(1, 'month').toDate(), moment().toDate()],
  }),
  handleSubmit: () => {
    console.log('Skip')
  },
})(BarGraphRTL)

export default EnhancedBarGraphRTL
